import React from 'react';
import { InformationContextValue } from './types';

const InformationDashboard409AContext = React.createContext<InformationContextValue>({
  handleGetCurrentInformationRequests: (): Promise<void> => new Promise(() => {}),
  currentDocuments: undefined,
  addFilesToFolder: async () => new Promise(() => {}),
  refreshDocuments: () => null,
  downloadDocument: () => null,
  updateSubFolder: async () => new Promise(() => {}),
  featuresObjects: {},
  permissions: {
    canUseInfoRequestLedger: false,
    canViewDocuments: false,
    canDownloadDocuments: false,
    canEditSetup: false,
    canSendInfoRequest: false,
    canCopyPortalLink: false,
  },
  updatePortalLinksAndTask: () => new Promise(() => {}),
  is409a: false,
});

export default InformationDashboard409AContext;
